import * as React from 'react'

/**
 * One editor context-menu row. A disabled row drops its click handler and is marked
 * `aria-disabled`, which also takes it out of the shell's keyboard navigation.
 */
export function ContextMenuItem({
  children,
  onClick,
  disabled,
}: {
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
}) {
  return (
    <div
      className={`relative flex cursor-default select-none items-center justify-between gap-3 whitespace-nowrap rounded-sm px-2 py-1.5 text-sm outline-none transition-colors ${
        disabled
          ? 'pointer-events-none opacity-50'
          : 'hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground data-[highlighted=true]:bg-accent data-[highlighted=true]:text-accent-foreground'
      }`}
      onClick={disabled ? undefined : onClick}
      role="menuitem"
      aria-disabled={disabled}
    >
      {children}
    </div>
  )
}
